<template>
  <span
    class="collapse-menu el-icon-s-fold"
    :class="[collapse ? 'transform' : '']"
    @click="handleChangeCollapse"
  />
</template>
<script>
export default {
  props: ["collapse"],
  methods: {
    handleChangeCollapse() {
      this.$emit("toggleMenu");
    },
  },
};
</script>
<style lang="less" scoped>
.collapse-menu {
  float: left;
  font-size: 22px;
  height: 50px;
  line-height: 50px;
  padding: 0 15px;
  cursor: pointer;
  transition: all 0.28s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.025);
  }
  &.transform {
    transform: rotate(180deg);
  }
}
</style>